import { useState, useEffect } from 'react';
import { throttleToAnimationFrame } from '@utils/common';

/**
 * responsively adjust the size of the stroke for outlined shapes so that it
 * scales along with the shape itself.
 */
const useStrokeWidth = (ref, naturalStrokeWidth, naturalSize) => {
  const [strokeWidth, setStrokeWidth] = useState(naturalStrokeWidth);
  const resizeStroke = () => {
    if (ref.current === null) {
      return;
    }
    const scaleHorizontal = ref.current.clientWidth / naturalSize.width;
    const scaleVertical = ref.current.clientHeight / naturalSize.height;
    const scale = Math.min(scaleHorizontal, scaleVertical);
    setStrokeWidth(naturalStrokeWidth * scale);
  };
  useEffect(() => {
    const handleResize = throttleToAnimationFrame(resizeStroke);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
  useEffect(resizeStroke);
  return strokeWidth;
};

export { useStrokeWidth };
//# sourceMappingURL=useStrokeWidth.js.map
